import { render, staticRenderFns } from "./TwoTableDrag2.vue?vue&type=template&id=28226b20"
import script from "./TwoTableDrag2.vue?vue&type=script&lang=js"
export * from "./TwoTableDrag2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports